// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLinesStyles } from "@steiner/Overrides/Widgets/Cart/CartLines";
import { color, hideElementOnPrint, styledScrollbar, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

cartLinesStyles.headerWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px;
        gap: 8px 20px;
        background: ${color("primary")};
        ${xScreen("lte", "xs")} {
            flex-wrap: wrap;
        }
    `,
};

cartLinesStyles.headerText = {
    variant: "h3",
    color: "common.ui1",
    css: css`
        margin: 0;
    `,
};

cartLinesStyles.header = {
    itemCountText: {
        size: 16,
        lineHeight: "19px",
        color: "common.ui1",
        css: hideElementOnPrint,
    },
    itemCountTextPrintOnly: {
        size: 16,
        lineHeight: "19px",
        color: "common.ui1",
        css: css`
            display: none;

            @media print {
                display: block;
            }
        `,
    },
};

cartLinesStyles.centeringWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        ${({ isLoading }: any) =>
            isLoading &&
            css`
                height: 300px;
            `};
    `,
};

cartLinesStyles.noCartLinesNotification = {
    css: css`
        margin-bottom: 24px;
    `,
};

cartLinesStyles.cartLinesHeaderContainer = {
    css: css`
        max-height: 750px;
        ${styledScrollbar()}

        @media print {
            display: block;
            max-height: 100%;
        }
    `,
};
